<div class="view-wrapper list-page">
  <div class="doublons-wrapper">
    <div class="list-container" *ngIf="criteresRegroupementVisible" >
      <dx-list
        [dataSource]="criteresRegroupement"
        selectionMode="all"
        selectAllMode="page"
        [showSelectionControls]="true"
        [selectedItemKeys]="columnNames"
        [selectByClick]="true"
        [showSelectionControls]="true"
        height="auto"
        (onSelectionChanged)="onCritereRegroupementChanged($event)"
        [width]="450"
        class="treeview"
      >
      </dx-list>
      <dx-button style="margin-top: 1rem; width : 140px" stylingMode="contained" type="normal" text="Filtrer" (onClick)="setDataSource()"></dx-button>
    </div>
     <!-- #region DataGrid -->
    <dx-data-grid
    #gridContainer
    id="gridContainer"
    class="grid theme-dependent"
    noDataText="Aucun élément trouvé"
    [dataSource]="dataSource"
    [allowColumnReordering]="true"
    [columnAutoWidth]="true"
    [allowColumnResizing]="true"
    height="100%"
    width="100%"
    [remoteOperations]="{ groupPaging: true }"
    [showBorders]="true"
    (onExporting)="onExporting($event)"
    [masterDetail]="{ enabled: true, template: 'detail' }"
    >
    <!-- #region Toolbar -->
    <dxo-toolbar>
      <dxi-item location="before">
        <dx-button icon="menu" (onClick)="onToggleCriteresRegroupementDisplay()" hint="Afficher / Cacher les critères de regroupement"
          stylingMode="text"></dx-button>
      </dxi-item>
      <dxi-item location="before">
        <div *dxTemplate class="grid-header">Doublons clients</div>
      </dxi-item>
      <dxi-item>
        <div *dxTemplate>
          <dx-button icon="refresh" stylingMode="text" hint="Rafraîchir" (onClick)="setDataSource()"></dx-button>
        </div>
      </dxi-item>
      <dxi-item>
        <div *dxTemplate>
          <dx-button stylingMode="text" icon="deletetable" hint="Réinitialiser les filtres"
            (onClick)="clearDatagridFilters()"></dx-button>
        </div>
      </dxi-item>
      <dxi-item name="exportButton"></dxi-item>
      <dxi-item name="columnChooserButton"></dxi-item>
    </dxo-toolbar>
    <!-- #endregion -->

    <!-- #region Options -->
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-header-filter [visible]="true">
      <dxo-search [enabled]="true"></dxo-search>
    </dxo-header-filter>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-export [enabled]="true" [fileName]="partenaireCategorieIntitule"></dxo-export>
    <dxo-scrolling showScrollbar="always"></dxo-scrolling>
    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-grouping #expand [autoExpandAll]="false"></dxo-grouping>
    <dxo-paging [enabled]="true" [pageSize]="50"></dxo-paging>
    <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[50, 100, 150]" [showInfo]="true" [visible]="true"></dxo-pager>
    <dxo-remote-operations [sorting]="true" [grouping]="true" [filtering]="true" [paging]="true"></dxo-remote-operations>
    <dxo-state-storing [storageKey]="storageKey" [enabled]="true" appStorage></dxo-state-storing>
    <!-- #endregion -->

    <!-- #region Colonnes -->

    <dxi-column [visible]="false" dataField="intitule" caption="Intitulé"></dxi-column>
    <dxi-column [visible]="false" dataField="nom" caption="Nom"></dxi-column>
    <dxi-column [visible]="false" dataField="prenom" caption="Prenom"></dxi-column>
    <dxi-column [visible]="false" dataField="dateNaissance" caption="Date de naissance" dataType="date"></dxi-column>
    <dxi-column [visible]="false" dataField="email" caption="Email"></dxi-column>
    <dxi-column [visible]="false" dataField="telephone" caption="Téléphone"></dxi-column>
    <dxi-column [visible]="false" dataField="adresse" caption="Adresse"></dxi-column>
    <dxi-column [visible]="false" dataField="codePostal" caption="Code postal"></dxi-column>
    <dxi-column [visible]="false" dataField="ville" caption="Ville"></dxi-column>
    <dxi-column [visible]="false" dataField="pays" caption="Pays"></dxi-column>
    <dxi-column [visible]="false" dataField="identifiantEntreprise" caption="N° Tahiti / Ridet"></dxi-column>
    <dxi-column [visible]="true" [width]="200" dataField="typePartenaire" caption="Type de partenaire"></dxi-column>
    <dxi-column [visible]="true" [width]="100" dataField="nombreDoublons" caption="Nombre de doublons"></dxi-column>

    <div *dxTemplate="let detail of 'detail'">
      <app-partenaire-doublons-details (setDataSourceSignal)="handleDetailSignal($event)" [dataSource]="detail.data.partenaires"></app-partenaire-doublons-details>
    </div>
    <!-- #endregion -->
    </dx-data-grid>
  </div>
 </div>
